export const GET_MENU = "GET_MENU"
export const GET_MENU_SUCCESS = "GET_MENU_SUCCESS"
